const type = 'RESET_CARDS';

const resetCards = (data) => ({
  data,
  type,
});

export { type };
export default resetCards;
